import { PROMOTION_TYPE } from 'typings'

enum Languages {
  BG = 'bg',
  DE = 'de',
  EN = 'en',
  ES = 'es',
  FR = 'fr',
  IT = 'it',
  JA = 'ja',
  KO = 'ko',
  NL = 'nl',
  PL = 'pl',
  PT = 'pt',
  RO = 'ro',
  TH = 'th',
}

export const supportedLanguages = {
  [PROMOTION_TYPE.BUY_TOGETHER]: [
    Languages.PT,
    Languages.ES,
    Languages.EN,
    Languages.FR,
    Languages.IT,
    Languages.DE,
    Languages.NL,
    Languages.RO,
    Languages.BG,
    Languages.KO,
    Languages.JA,
    Languages.TH,
    Languages.PL
  ],
  [PROMOTION_TYPE.MORE_FOR_LESS]: [
    Languages.PT,
    Languages.ES,
    Languages.EN,
    Languages.FR,
    Languages.IT,
    Languages.DE,
    Languages.NL,
    Languages.RO,
    Languages.BG,
    Languages.KO,
    Languages.JA,
    Languages.TH,
    Languages.PL,
  ],
  [PROMOTION_TYPE.PROGRESSIVE]: [
    Languages.PT,
    Languages.ES,
    Languages.EN,
    Languages.FR,
    Languages.IT,
    Languages.DE,
    Languages.NL,
    Languages.RO,
    Languages.BG,
    Languages.KO,
    Languages.JA,
    Languages.TH,
    Languages.PL,
  ],
  [PROMOTION_TYPE.BUY_AND_WIN]: [
    Languages.PT,
    Languages.ES,
    Languages.EN,
    Languages.FR,
    Languages.IT,
    Languages.DE,
    Languages.NL,
    Languages.RO,
    Languages.BG,
    Languages.KO,
    Languages.JA,
    Languages.TH,
    Languages.PL,
  ],
  [PROMOTION_TYPE.REGULAR]: [
    Languages.PT,
    Languages.ES,
    Languages.EN,
    Languages.FR,
    Languages.IT,
    Languages.DE,
    Languages.NL,
    Languages.RO,
    Languages.BG,
    Languages.KO,
    Languages.JA,
    Languages.TH,
    Languages.PL,

  ],
  [PROMOTION_TYPE.CAMPAIGN]: [
    Languages.PT,
    Languages.ES,
    Languages.EN,
    Languages.FR,
    Languages.IT,
    Languages.DE,
    Languages.NL,
    Languages.RO,
    Languages.BG,
    Languages.KO,
    Languages.JA,
    Languages.TH,
    Languages.PL,
  ],
}

export function languageIsSupported(
  type: null | string,
  locale: string | undefined = ''
): boolean {
  const [language] = locale.split('-')

  if (!type || !language) return false

  const languageFilter: string[] | undefined = supportedLanguages[type]
  if (!languageFilter) return true

  return languageFilter.includes(language)
}
